import React, { useState, useMemo, useEffect } from 'react';

const DetailsStep = ({ onSubmit, formState, isSubmitting, calculateDiscountBreakdown, getDiscountForTime, selectedEvent }) => {
    const [details, setDetails] = useState({ name: '', email: '', phone: '', notes: '', groupReason: '' });
    
    const discountInfo = useMemo(() => {
        if (selectedEvent) return [];
        const numPessoas = parseInt(formState.guests) || 1;
        if (calculateDiscountBreakdown) return calculateDiscountBreakdown(formState.date, formState.time, numPessoas);
        if (getDiscountForTime) {
            const disc = getDiscountForTime(formState.date, formState.time);
            return [{ count: numPessoas, percent: disc }];
        }
        return [];
    }, [formState, calculateDiscountBreakdown, getDiscountForTime, selectedEvent]);

    const discountSummaryText = useMemo(() => {
        if (discountInfo.length === 0 || discountInfo.every(d => d.percent === 0)) return "Reserva Normal";
        return discountInfo.map(item => item.percent > 0 ? `${item.count}x -${item.percent}%` : `${item.count}x Normal`).join(', ');
    }, [discountInfo]);

    useEffect(() => {
        try {
            const saved = localStorage.getItem('vintage_praia_customer_details');
            if (saved) setDetails(p => ({...p, ...JSON.parse(saved)}));
        } catch (e) {}
    }, []);

    const handleChange = (e) => setDetails(p => ({...p, [e.target.id]: e.target.value}));
    const handleSubmit = (e) => { e.preventDefault(); onSubmit(details); };

    // Estilos comuns para inputs
    const inputStyle = {
        width: '100%',
        padding: '12px',
        borderRadius: '8px',
        border: '1px solid #d1d5db',
        fontSize: '14px',
        outline: 'none',
        boxSizing: 'border-box', // Garante que padding não aumenta largura
        marginBottom: '0'
    };

    const labelStyle = {
        display: 'block',
        fontSize: '14px',
        fontWeight: '500',
        color: '#374151',
        marginBottom: '6px'
    };

    return (
        <form onSubmit={handleSubmit} className="animate-fade-in" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            
            {/* CAIXA DE RESUMO (Estilo Isolado) */}
            <div style={{
                backgroundColor: '#f9fafb',
                padding: '20px',
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                marginBottom: '8px'
            }}>
                <h4 style={{ fontWeight: 'bold', color: '#1f2937', borderBottom: '1px solid #e5e7eb', paddingBottom: '8px', marginBottom: '12px', fontSize: '14px', textTransform: 'uppercase' }}>
                    Resumo da Reserva
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '14px', color: '#4b5563' }}>
                    <div>Data: <strong style={{ color: '#111' }}>{formState.date}</strong></div>
                    <div>Hora: <strong style={{ color: '#111' }}>{formState.time}</strong></div>
                    <div>Pessoas: <strong style={{ color: '#111' }}>{formState.guests}</strong></div>
                </div>
                
                <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', color: '#6b7280' }}>Condição:</span>
                    <span style={{ fontSize: '14px', fontWeight: 'bold', color: discountSummaryText.includes('%') ? '#16a34a' : '#4b5563' }}>
                        {discountSummaryText}
                    </span>
                </div>
            </div>

            {/* CAMPOS DO FORMULÁRIO */}
            <div>
                <label htmlFor="name" style={labelStyle}>Nome Completo</label>
                <input type="text" id="name" required value={details.name} onChange={handleChange} style={inputStyle} />
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div>
                    <label htmlFor="phone" style={labelStyle}>Telemóvel</label>
                    <input type="tel" id="phone" required value={details.phone} onChange={handleChange} style={inputStyle} />
                </div>
                <div>
                    <label htmlFor="email" style={labelStyle}>Email</label>
                    <input type="email" id="email" required value={details.email} onChange={handleChange} style={inputStyle} />
                </div>
            </div>

            {formState.isGroup ? (
                <div>
                    <label style={labelStyle}>Motivo do Grupo</label>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                        {['Aniversário', 'Jantar de Empresa', 'Confraternização'].map(r => (
                            <button key={r} type="button" onClick={() => setDetails(p => ({...p, groupReason: r}))} style={{
                                padding: '6px 12px', borderRadius: '999px', border: '1px solid #d1d5db', fontSize: '12px',
                                backgroundColor: details.groupReason === r ? '#f59e0b' : 'white',
                                color: details.groupReason === r ? 'white' : '#374151',
                                cursor: 'pointer'
                            }}>{r}</button>
                        ))}
                    </div>
                </div>
            ) : (
                <div>
                    <label htmlFor="notes" style={labelStyle}>Observações</label>
                    <textarea id="notes" value={details.notes} onChange={handleChange} style={{...inputStyle, minHeight: '80px'}} rows="2"></textarea>
                </div>
            )}

            <button type="submit" disabled={isSubmitting} style={{
                width: '100%',
                backgroundColor: '#d97706',
                color: 'white',
                fontWeight: 'bold',
                padding: '14px',
                borderRadius: '8px',
                border: 'none',
                cursor: isSubmitting ? 'wait' : 'pointer',
                opacity: isSubmitting ? 0.7 : 1,
                fontSize: '16px',
                marginTop: '10px'
            }}>
                {isSubmitting ? 'A processar...' : 'Confirmar Reserva'}
            </button>
        </form>
    );
};

export default DetailsStep;